import React from "react";
import classes from "./WordGameLayout.module.css";

const WordGameLayout = ({ children }) => {
  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>{children}</div>
    </div>
  );
};

export default WordGameLayout;
